"use strict";

var getValueOfKeyMatching = require('../getValueOfKeyMatching');

function PlaceCards(params) {
  var quantity = getValueOfKeyMatching(params, /multi_quantity/);
  var place_card_style = getValueOfKeyMatching(params, /placecard_style/);
  var meal_indicators = getValueOfKeyMatching(params, /meal_indicators/);
  this.placeCards.add({
    quantity: quantity,
    place_card_style: place_card_style,
    meal_indicators: meal_indicators
  });
}

module.exports = PlaceCards;